module.exports = __webpack_public_path__ + "static/dj-category-042a7608c4b6f947c0ebb981ee513f82.png";